import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

const generateParticles = (count) => {
  const particles = [];
  for (let i = 0; i < count; i++) {
    const angle = Math.random() * Math.PI * 2;
    const spread = 70 + Math.random() * 160;
    const size = 1.2 + Math.random() * 2.8;
    const startAngle = Math.random() * Math.PI * 2;
    const startRx = Math.random() * 55;
    const startRy = Math.random() * 30;
    particles.push({
      id: i,
      size,
      startX: Math.cos(startAngle) * startRx,
      startY: Math.sin(startAngle) * startRy - 15,
      endX: Math.cos(angle) * spread,
      endY: Math.sin(angle) * spread,
      delay: Math.random() * 0.25,
      duration: 0.5 + Math.random() * 0.5,
      opacity: 0.25 + Math.random() * 0.55,
    });
  }
  return particles;
};

export const ParticleOverlay = () => {
  const particles = useMemo(() => generateParticles(50), []);

  return (
    <div className="particle-overlay" aria-hidden="true">
      {particles.map((p) => (
        <motion.div
          key={p.id}
          style={{
            width: p.size,
            height: p.size,
            left: '50%',
            top: '43%',
            borderRadius: '50%',
            position: 'absolute',
            background: `rgba(215, 215, 230, ${p.opacity})`,
          }}
          initial={{ x: p.startX, y: p.startY, opacity: p.opacity, scale: 1 }}
          animate={{ x: p.endX, y: p.endY, opacity: 0, scale: 0.15 }}
          transition={{
            duration: p.duration,
            delay: p.delay,
            ease: [0.15, 0.8, 0.35, 1],
          }}
        />
      ))}
    </div>
  );
};
